import { render } from "./ProgramManagement.vue?vue&type=template&id=208d91a2"
import script from "./ProgramManagement.vue?vue&type=script&lang=js"
export * from "./ProgramManagement.vue?vue&type=script&lang=js"

import "./ProgramManagement.vue?vue&type=style&index=0&id=208d91a2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__